import { OrderCategory } from "../../api/endpoints/Order";
import { TOrderProductData } from "../../api/endpoints/OrderProduct";

export const BASKET_PRODUCT_ADD_COMPLETED = 'BASKET_PRODUCT_ADD_COMPLETED';

export interface IBasketProductAddCompletedAction {
  type: typeof BASKET_PRODUCT_ADD_COMPLETED,
  product: TOrderProductData<OrderCategory.REALTIME>
}

const addProductToBasket = (product: TOrderProductData<OrderCategory.REALTIME>): IBasketProductAddCompletedAction => {
  return {
    type: BASKET_PRODUCT_ADD_COMPLETED,
    product
  }
}

export const BASKET_PRODUCT_REMOVE_COMPLETED = 'BASKET_PRODUCT_REMOVE_COMPLETED';

export interface IBasketProductRemoveCompletedAction {
  type: typeof BASKET_PRODUCT_REMOVE_COMPLETED,
  productId: string
}

const removeProductFromBasket = (productId: string): IBasketProductRemoveCompletedAction => {
  return {
    type: BASKET_PRODUCT_REMOVE_COMPLETED,
    productId
  }
}

export const BASKET_CLEAR_COMPLETED = 'BASKET_CLEAR_COMPLETED';

export interface IBasketClearCompletedAction {
  type: typeof BASKET_CLEAR_COMPLETED
}

const clearBasket = (): IBasketClearCompletedAction => {
  return {
    type: BASKET_CLEAR_COMPLETED
  }
}

export {
  addProductToBasket,
  removeProductFromBasket,
  clearBasket
}
